import Section from '~/src/features/tariffBuilder/components/Section';
import FinalContainer from '~/src/features/tariffBuilder/containers/FinalContainer';

const Final = (): JSX.Element => {
    return <>
        <Section>
            <FinalContainer/>
        </Section>
    </>;
};

export default Final;
